import PropTypes from "prop-types";
import BaseInputPage from "../basecomponents/BaseInputPage";
import { connect } from "react-redux";

import { InputField } from "../components/form";
import { ButtonLink } from "../components/button";
import { SmallSpinner } from "../components/loaders";

import { registerUser } from "../actions/authActions";
import { checkUserLoggedIn } from "../utils/routing";
class Register extends BaseInputPage {
  state = {
    name: "",
    email: "",
    phone: "",
    password: "",
    loading: false,
    errors: {},
  };

  componentDidMount() {
    this.checkUserLoggedIn();
  }

  checkUserLoggedIn() {
    checkUserLoggedIn(this.props);
  }

  static getDerivedStateFromProps(nextProps) {
    let newState = {
      errors: null,
      changed: false,
    };
    if (nextProps.errors) {
      newState.errors = nextProps.errors;
      newState.changed = true;
    }
    return newState.changed ? newState : null;
  }

  getForm() {
    const { name, email, phone, password, errors, loading } = this.state;
    return (
      <>
        <InputField
          onChange={this.onChangeTextInput}
          id="name"
          value={name}
          error={errors}
          placeholder="Nombre"
          disabled={loading}
        />

        <InputField
          onChange={this.onChangeTextInput}
          id="email"
          type="email"
          value={email}
          error={errors}
          placeholder="Correo electronico"
          disabled={loading}
        />

        <InputField
          onChange={this.onChangeTextInput}
          id="phone"
          type="phone"
          value={phone}
          error={errors}
          placeholder="Telefono"
          disabled={loading}
        />

        <InputField
          onChange={this.onChangeTextInput}
          id="password"
          type="password"
          value={password}
          error={errors}
          placeholder="Clave"
          disabled={loading}
        />

        {loading && <SmallSpinner />}
      </>
    );
  }

  onSubmit = (event) => {
    event.preventDefault();
    const { name, email, password, phone } = this.state;
    this.setState({ loading: true });
    // @ts-ignore
    this.props.registerUser(
      {
        email,
        password,
        name,
        phone,
      },
      () => {
        this.setState({
          loading: false,
        });
        this.checkUserLoggedIn();
      }
    );
  };

  render() {
    const { loading } = this.state;
    return this.renderPage(
      <div className="containerbar authenticate-bg">
        <div className="container">
          <div className="auth-box login-box">
            <div className="row no-gutters align-items-center justify-content-center">
              <div className="col-md-6 col-lg-5">
                <div className="auth-box-right">
                  <div className="card">
                    <div className="card-body">
                      <form onSubmit={this.onSubmit}>
                        <div className="form-head">
                          <a href="#!" className="logo">
                            <img
                              src="/images/logo.png"
                              className="img-fluid"
                              alt="logo"
                            />
                          </a>
                        </div>
                        {this.getForm()}

                        <button
                          type="submit"
                          className="btn btn-success btn-lg btn-block font-18"
                          disabled={loading}
                        >
                          Registrarse
                        </button>
                      </form>
                      <p className="mb-0 mt-3">
                        Ya tienes una cuenta?{" "}
                        <ButtonLink href="/" text="Iniciar sesi&oacute;n" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// @ts-ignore
Register.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  registerUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { registerUser })(Register);
